module.exports = __webpack_public_path__ + "static/media/NO_HYDROGENS.0c10e0e8.svg";